import { render, staticRenderFns } from "./home3Dian5.vue?vue&type=template&id=2e53b044&scoped=true"
import script from "./home3Dian5.vue?vue&type=script&lang=js"
export * from "./home3Dian5.vue?vue&type=script&lang=js"
import style0 from "./home3Dian5.vue?vue&type=style&index=0&id=2e53b044&prod&lang=css"
import style1 from "./home3Dian5.vue?vue&type=style&index=1&id=2e53b044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53b044",
  null
  
)

export default component.exports